module.exports = __webpack_public_path__ + "img/coins-02.5b414449.svg";